import { render, staticRenderFns } from "./order-dashboard.vue?vue&type=template&id=75be2914&scoped=true&"
import script from "./order-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./order-dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-dashboard.scss?vue&type=style&index=0&id=75be2914&lang=scss&scoped=true&"
import style1 from "./order-dashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be2914",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75be2914')) {
      api.createRecord('75be2914', component.options)
    } else {
      api.reload('75be2914', component.options)
    }
    module.hot.accept("./order-dashboard.vue?vue&type=template&id=75be2914&scoped=true&", function () {
      api.rerender('75be2914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/order-dashboard/order-dashboard.vue"
export default component.exports